// US-072: pure helpers for the Create-PO reorder-parameter columns.
//
// The definitional reorder parameters are returned directly on each
// inventory_replenishment report row (the same report that powers Suggested Qty)
// once their column codes are requested — see buildCreateReportColumns, used by
// PurchaseOrderCreate.fetchData(). So a cell just reads `row[reportCode]`; no
// separate settings fetch or join is needed.
//
// Intentionally free of runtime imports so unit tests load without tripping the
// pre-existing dateformat ERR_REQUIRE_ESM issue.

/** A definitional reorder-parameter column shown read-only on the Create-PO table. */
export interface ReorderParamColumn {
  /** Stable column id used in the create-view column config. */
  id: string;
  /** Human-readable header label. */
  label: string;
  /** inventory_replenishment report column code carrying this value on the row. */
  reportCode: string;
}

export const REORDER_PARAM_COLUMNS: ReorderParamColumn[] = [
  { id: 'lead_time', label: 'Lead Time', reportCode: '[vendor_lead_time]' },
  { id: 'order_cycle', label: 'Order Cycle', reportCode: '[reorder_cycle]' },
  { id: 'min_order_qty', label: 'Min Order Qty', reportCode: '[min_order_quantity]' },
  { id: 'max_order_qty', label: 'Max Order Qty', reportCode: '[max_order_quantity]' },
  { id: 'fix_order_qty', label: 'Fix Order Qty', reportCode: '[fixed_order_quantity]' },
  { id: 'case_qty', label: 'Case Qty', reportCode: '[case_quantity]' },
  { id: 'min_inventory_qty', label: 'Min Inventory Qty', reportCode: '[min_inventory_quantity]' },
  { id: 'max_inventory_qty', label: 'Max Inventory Qty', reportCode: '[max_inventory_quantity]' },
  { id: 'min_stock_cover_days', label: 'Min Stock-Cover Days', reportCode: '[min_stock_cover_days]' },
  { id: 'max_stock_cover_days', label: 'Max Stock-Cover Days', reportCode: '[max_stock_cover_days]' },
];

/**
 * Render a reorder-parameter cell. null / undefined / '' collapse to an em dash;
 * 0 renders as "0" (not blank). Load-bearing: never use a falsy check here.
 */
export function formatReorderParamCell(value: number | null | undefined | string): string {
  if (value === null || value === undefined || value === '') {
    return '—';
  }
  return String(value);
}
